<div class="wizard" *ngIf="workflowItem">
	<div class="titlerow">
		<div class="closeButtonColumn">
			<!-- Wizard verlassen -->
			<button *ngIf="!workflowItem.showOverview"
					nz-button nzType="secondary" type="button"
					(click)="showWorkflow()" class="big-back-button"
			>
				<i nz-icon nzType="close"></i>
			</button>
			<!-- Zur Fragebogenübersicht -->
			<button *ngIf="workflowItem.showOverview"
					nz-button nzType="secondary" type="button"
					(click)="showOverview()" class="big-back-button"
			>
				<i nz-icon nzType="close"></i>
			</button>
		</div>
		<div class="titlecolumn" *ngIf="page">
			<h2 class="big-title" *ngIf="finishedAndLocked">{{ pageTitle }} ({{ 'status.finished' | translate }})</h2>
			<h2 class="big-title" *ngIf="!finishedAndLocked">{{ pageTitle }}</h2>
		</div>
		<div class="infoButtonColumn">
			<!-- fehlende Hardware anzeigen -->
			<button *ngIf="!finishedAndLocked && page.missingDevices?.length"
				[hidden]="!isContentPage"
				(click)="showMissingDevicesModal()"
				nz-button nzType="warning" type="button" class="big-back-button warning-button" [ngClass]="{'mr-4': false}"
			>
				<i nz-icon nzType="exclamation"></i>
			</button>
			<!-- Fehlerwerte Indikator -->
			<workflow-wizard-missing-value-button *ngIf="!isEpilog && hasAnyMissingValueKey" [disabled]="!hasWorkflowWritePermission"
					[page]="page" [finishedAndLocked]="finishedAndLocked" (fehlwertAdded)="fehlwertAdded()" (status)="statusFehlwert($event)"
			></workflow-wizard-missing-value-button>
		</div>
	</div>

	<div *ngIf="page" class="contentrow content-observer">
		<div class="description-block"
			[ngClass]="{'height-40': page?.alignBottom}"
			*ngIf="isContentPage && description?.length && !page?.suppressDescription && !overwriteDescriptionText && !suppressedByFehlwert"
		>
			<div markdown [data]="description" class="markdown big-text description-observer description-text">
			</div>
		</div>
		<div class="description-block" [ngClass]="{'height-40': page?.alignBottom}" *ngIf="isContentPage && overwriteDescriptionText">
			<div markdown [data]="overwriteDescriptionText" class="markdown big-text description-observer description-text">
			</div>
		</div>
		<div class="content-block" [ngClass]="{'align-with-text': page?.alignBottom, 'center-content': !page?.alignBottom, 'full-height': hasFullHeight}">
			<form style="height: 100%; width: 100%">
				<ng-container class="full-height">
					<div *ngIf="isContentPage" nz-row
						class="wizardContent big-question question-observer full-height"
						[ngClass]="{'no-padding': !hasOnlyChoiceQuestion}"
						nzJustify="center"
						nzAlign="middle"
						style="height: 100%">
						<div nz-col nzSpan="24" class="big-question-content full-height" [ngSwitch]="page.question?.type">
							<workflow-questionnaire-block-question *ngSwitchCase="'BlockQuestion'"
																	class="big-question center full-height"
																	[justify]="!page.alignBottom ? 'space-around' : 'start'"
																	[question]="page.question"
																	[hasWorkflowWritePermission]="hasWorkflowWritePermission"
																	[finishedAndLocked]="finishedAndLocked"
																	[hideItemText]="hasItemTexts"
																	[isWizard]="true"
																	[layout]="page.layout"
																	(valid)="updateInputValidity($event, 0, 0)"
																	[group]="page" [blockMissingValueKey]="page.missingValueKey"
																	(overwriteDescriptionText)="updateOverwriteDescriptionText($event)"
							>
							</workflow-questionnaire-block-question>
							<workflow-special-question *ngSwitchCase="isSpecialQuestion && page.question?.type"
														(valid)="updateInputValidity($event, 0, 0)"
														[question]="page.question" [isWizard]="true"
														[hasWorkflowWritePermission]="hasWorkflowWritePermission"
														[currentPage]="page.subpage"
														[finishedAndLocked]="finishedAndLocked"
														[epilogUrl]="epilogUrlSlug"
														[prologUrl]="prologUrlSlug"
														[nextUrl]="nextUrlSlug"
														[workflowItemId]="workflowItem.id"
														[groupMissingValueKey]="page.missingValueKeyGroup"
														[overviewConfigs]="page.groupOverview"
							>
							</workflow-special-question>
							<div *ngSwitchDefault>
								Unbekannter Typ: {{ page.question?.type }}
							</div>
						</div>
					</div>
					<ng-container *ngIf="!isContentPage">
						<workflow-special-question-epilog *ngIf="page.epilogComponent"
								[appWorkflowItemKey]="page.key"
								[missingValueKey]="page.missingValueKey"
								appWorkflowItemData="auto"
								[component]="page.epilogComponent"
								[overviewConfigs]="page.groupOverview"
								[ngClass]="{'center-content': page.question?.centered}"
								[finishedAndLocked]="finishedAndLocked"
								class="markdown big-text preface question-observer"
						></workflow-special-question-epilog>

						<div markdown *ngIf="!page.epilogComponent"
							[appClassSelector]="{
								'!text-only': 'img,table',
								'height-100p': '.d-flex'
							}"
							[ngClass]="{
								'center-content': page.question?.centered
							}"
							class="markdown big-text preface question-observer"
							[data]="description"
						></div>
						<div nz-col [nzSpan]="24">
							<nz-alert *ngIf="missingDevices?.length && !finishedAndLocked && hasWorkflowWritePermission"
												nzType="warning" nzShowIcon
												nzMessage="{{ 'message.warning.devices_missing' | translate }}"
												[nzDescription]="missingDevicesList"
												class="big-warning"
							></nz-alert>
							<ng-template #missingDevicesList>
								<perfect-scrollbar>
									<ul class="warning-list">
										<li *ngFor="let missingDevice of missingDevices">{{ missingDevice | translate }}</li>
									</ul>
								</perfect-scrollbar>
							</ng-template>
						</div>
					</ng-container>
				</ng-container>
			</form>
		</div>

		<!--TODO GSP-231 Bedingungen und Funktionen der Extrabuttons-->
		<div class="buttonrow extrabuttons" *ngIf="false">
			<div class="left-buttons"></div>
			<div class="right-buttons">
				<!--Vorwärts für Seiten einzelner Fragen-->
				<button nz-button nzType="primary" class="big-button right-one">
					1
				</button>
			</div>
		</div>
	</div>

	<div class="buttonrow" *ngIf="page">
		<div class="left-buttons">
			<!-- Standard-Zurück-Button -->
			<button *ngIf="hasPreviousPage" nz-button nzType="primary" [routerLink]="prevPageUrl" class="big-button left-one" #swipePreviewPrevious>
				<i nz-icon nzType="left"></i>
				{{ 'actions.back' | translate }}<span *ngIf="showAsterisk">*</span>
			</button >
			<!-- Zum-Prolog-Button -->
		</div>
		<div class="right-buttons">
			<button *ngIf="hasRestartPage && !questionGroupStatus.hasMissingValue && !allNodesOfItemDisabled && hasWorkflowWritePermission"
					[disabled]="!isProlog && (!isPageSufficientFilled || !isAllValid)"
					nz-button nzType="primary" [routerLink]="restartUrl" class="big-button right-one" id="restartButton" #swipePreviewNext>
				{{ restartText | translate }}<i nz-icon nzType="right"></i>
			</button>

			<button *ngIf="hasNextPage && !page.disableNext && !showSkipButton"
					[disabled]="(!isProlog && (!isPageSufficientFilled || !isAllValid)) || disableNextButton"
					nz-button nzType="primary" [routerLink]="nextPageUrl" class="big-button right-one" id="nextButton" #swipePreviewNext>
				{{ nextText | translate }}<i nz-icon nzType="right"></i>
			</button>

			<button *ngIf="showSkipButton"
					nz-button nzType="primary" [routerLink]="nextQuestionGroupUrl"
					class="big-button right-one" id="skipButton" #swipePreviewNext>
				{{ 'actions.skip_question_group' | translate }}<i nz-icon nzType="right"></i>
			</button>

			<!-- Beenden, wenn es keine Frage mehr gibt -->
			<button *ngIf="!hasNextPage"
					[disabled]="finishWorkflowSplitbutton.disabled"
					nz-button nzType="primary"
					(click)="doCompletion()"
					class="big-button right-one" id="finishButton" #swipePreviewNext>
				<i nz-icon nzType="check"></i>{{ finishWorkflowSplitbutton.title | translate }}
			</button>
		</div>
	</div>

	<div class="touch-previews">
		<div class="previous-preview" #previousHover>
			<i nz-icon nzType="arrow-left"></i>
		</div>
		<div class="next-preview" #nextHover>
			<i nz-icon nzType="arrow-right"></i>
		</div>
	</div>
</div>

<ng-template appModal let-close #confirm="appModal">
	<nz-modal
		[nzMaskClosable]="false"
		nzVisible
		nzTitle="{{ 'workflow.modal.finish.title' | translate }}"
		(nzOnOk)="close(true)"
		(nzOnCancel)="close(false)"
		nzOkText="{{ confirmationModalConfig?.textOK || 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
	>
		{{ confirmationModalConfig?.textMessage || 'workflow.modal.finish.text' | translate }}
	</nz-modal>
</ng-template>
<nz-modal *ngIf="page"
		nzTitle="{{ 'workflow.modal.missingdevices.title' | translate }}"
		[nzVisible]="isVisibleMissingDevicesModal"
		nzOkText="{{ 'actions.OK' | translate }}"
		(nzOnCancel)="closeMissingDevicesModal()"
		(nzOnOk)="closeMissingDevicesModal()"
		[nzCancelText]="null"
>
	{{ 'workflow.modal.missingdevices.text' | translate }}
	<br />
	<ul>
		<li *ngFor="let missingDevice of page.missingDevices">{{ missingDevice | translate }}</li>
	</ul>
</nz-modal>
